export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },
  { code: 'th', name: 'ไทย', flag: '🇹🇭' },
  { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'id', name: 'Indonesia', flag: '🇮🇩' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'bs', name: 'Bosanski', flag: '🇧🇦' },
  { code: 'hu', name: 'Magyar', flag: '🇭🇺' },
  { code: 'hr', name: 'Hrvatski', flag: '🇭🇷' },
  { code: 'sr', name: 'Srpski', flag: '🇷🇸' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'ro', name: 'Română', flag: '🇷🇴' },
] as const

export type LangCode = (typeof languages)[number]['code']

export interface TranslationKeys {
  videoFile: string
  liveNow: string
  watching: string
  liveWebinar: string
  description: string
  joinLiveNow: string
  webinarInProgress: string
  polarTensorLiveWebinar: string
  happeningNow: string
  peopleWatching: string
  react: string
  avgProfit: string
  startedIn: string
  clients: string
  getStarted: string
  joinThousands: string
  webinarEnded: string
  signUpNow: string
  copyright: string
}

export const translations: Record<LangCode, TranslationKeys> = {
  en: {
    videoFile: 'Polar_Tensor_English.mp4',
    liveNow: 'LIVE NOW',
    watching: 'watching',
    liveWebinar: 'Live Webinar',
    description: 'Discover how Polar Tensor is revolutionizing the future of AI-powered trading with 22.04% average monthly profit based on past performance',
    joinLiveNow: 'Join Live Now',
    webinarInProgress: 'Webinar is in progress — Join now before it ends',
    polarTensorLiveWebinar: 'Polar Tensor Live Webinar',
    happeningNow: 'Happening now',
    peopleWatching: 'people watching',
    react: 'React',
    avgProfit: 'Avg. Profit',
    startedIn: 'Started in',
    clients: 'Clients',
    getStarted: 'Get Started Now, Earn Tomorrow',
    joinThousands: 'Join thousands of investors already benefiting from Polar Tensor',
    webinarEnded: 'The webinar has ended',
    signUpNow: 'Sign Up Now',
    copyright: '© 2025 Polar Tensor. All rights reserved.',
  },
  de: {
    videoFile: 'Polar_Tensor_German.mp4',
    liveNow: 'JETZT LIVE',
    watching: 'zuschauend',
    liveWebinar: 'Live-Webinar',
    description: 'Erfahren Sie, wie Polar Tensor die Zukunft des KI-gestützten Handels mit 22,04 % durchschnittlichem Monatsgewinn revolutioniert',
    joinLiveNow: 'Jetzt live beitreten',
    webinarInProgress: 'Webinar läuft — Treten Sie jetzt bei, bevor es endet',
    polarTensorLiveWebinar: 'Polar Tensor Live-Webinar',
    happeningNow: 'Jetzt live',
    peopleWatching: 'Zuschauer',
    react: 'Reagieren',
    avgProfit: 'Ø Gewinn',
    startedIn: 'Gegründet',
    clients: 'Kunden',
    getStarted: 'Jetzt starten, morgen verdienen',
    joinThousands: 'Schließen Sie sich Tausenden von Investoren an, die bereits von Polar Tensor profitieren',
    webinarEnded: 'Das Webinar ist beendet',
    signUpNow: 'Jetzt registrieren',
    copyright: '© 2025 Polar Tensor. Alle Rechte vorbehalten.',
  },
  es: {
    videoFile: 'Polar_Tensor_Spanish.mp4',
    liveNow: 'EN VIVO',
    watching: 'viendo',
    liveWebinar: 'Webinar en Vivo',
    description: 'Descubre cómo Polar Tensor está revolucionando el futuro del trading con IA con un 22,04% de beneficio mensual promedio basado en rendimientos pasados',
    joinLiveNow: 'Unirse en vivo ahora',
    webinarInProgress: 'El webinar está en curso — Únete ahora antes de que termine',
    polarTensorLiveWebinar: 'Webinar en Vivo de Polar Tensor',
    happeningNow: 'En curso ahora',
    peopleWatching: 'personas viendo',
    react: 'Reaccionar',
    avgProfit: 'Beneficio Prom.',
    startedIn: 'Desde',
    clients: 'Clientes',
    getStarted: 'Empieza ahora, gana mañana',
    joinThousands: 'Únete a miles de inversores que ya se benefician de Polar Tensor',
    webinarEnded: 'El webinar ha terminado',
    signUpNow: 'Regístrate ahora',
    copyright: '© 2025 Polar Tensor. Todos los derechos reservados.',
  },
  pt: {
    videoFile: 'Polar_Tensor_Portuguese_Brazil.mp4',
    liveNow: 'AO VIVO',
    watching: 'assistindo',
    liveWebinar: 'Webinar ao Vivo',
    description: 'Descubra como a Polar Tensor está revolucionando o futuro do trading com IA com 22,04% de lucro mensal médio baseado em desempenho passado',
    joinLiveNow: 'Participar ao vivo agora',
    webinarInProgress: 'O webinar está em andamento — Entre agora antes que termine',
    polarTensorLiveWebinar: 'Webinar ao Vivo da Polar Tensor',
    happeningNow: 'Acontecendo agora',
    peopleWatching: 'pessoas assistindo',
    react: 'Reagir',
    avgProfit: 'Lucro Méd.',
    startedIn: 'Desde',
    clients: 'Clientes',
    getStarted: 'Comece agora, ganhe amanhã',
    joinThousands: 'Junte-se a milhares de investidores que já se beneficiam da Polar Tensor',
    webinarEnded: 'O webinar terminou',
    signUpNow: 'Inscreva-se agora',
    copyright: '© 2025 Polar Tensor. Todos os direitos reservados.',
  },
  ru: {
    videoFile: 'Polar_Tensor_Russian.mp4',
    liveNow: 'ПРЯМОЙ ЭФИР',
    watching: 'смотрят',
    liveWebinar: 'Прямой эфир вебинара',
    description: 'Узнайте, как Polar Tensor революционизирует будущее торговли с ИИ со средней ежемесячной прибылью 22,04% на основе прошлых результатов',
    joinLiveNow: 'Присоединиться сейчас',
    webinarInProgress: 'Вебинар идёт — Присоединяйтесь, пока не закончился',
    polarTensorLiveWebinar: 'Вебинар Polar Tensor в прямом эфире',
    happeningNow: 'Идёт сейчас',
    peopleWatching: 'зрителей',
    react: 'Реакция',
    avgProfit: 'Ср. прибыль',
    startedIn: 'С',
    clients: 'Клиенты',
    getStarted: 'Начни сейчас, зарабатывай завтра',
    joinThousands: 'Присоединяйтесь к тысячам инвесторов, которые уже извлекают выгоду из Polar Tensor',
    webinarEnded: 'Вебинар завершён',
    signUpNow: 'Зарегистрироваться',
    copyright: '© 2025 Polar Tensor. Все права защищены.',
  },
  pl: {
    videoFile: 'Polar_Tensor_Polish.mp4',
    liveNow: 'NA ŻYWO',
    watching: 'ogląda',
    liveWebinar: 'Webinar na żywo',
    description: 'Odkryj, jak Polar Tensor rewolucjonizuje przyszłość handlu opartego na AI ze średnim miesięcznym zyskiem 22,04% na podstawie dotychczasowych wyników',
    joinLiveNow: 'Dołącz na żywo',
    webinarInProgress: 'Webinar trwa — Dołącz zanim się skończy',
    polarTensorLiveWebinar: 'Webinar na żywo Polar Tensor',
    happeningNow: 'Trwa teraz',
    peopleWatching: 'osób ogląda',
    react: 'Reaguj',
    avgProfit: 'Śr. zysk',
    startedIn: 'Od',
    clients: 'Klienci',
    getStarted: 'Zacznij teraz, zarabiaj jutro',
    joinThousands: 'Dołącz do tysięcy inwestorów, którzy już korzystają z Polar Tensor',
    webinarEnded: 'Webinar się zakończył',
    signUpNow: 'Zarejestruj się',
    copyright: '© 2025 Polar Tensor. Wszelkie prawa zastrzeżone.',
  },
  fr: {
    videoFile: 'Polar_Tensor_French.mp4',
    liveNow: 'EN DIRECT',
    watching: 'en train de regarder',
    liveWebinar: 'Webinaire en direct',
    description: "Découvrez comment Polar Tensor révolutionne l'avenir du trading alimenté par l'IA avec un profit mensuel moyen de 22,04 % basé sur les performances passées",
    joinLiveNow: 'Rejoindre en direct',
    webinarInProgress: 'Le webinaire est en cours — Rejoignez avant la fin',
    polarTensorLiveWebinar: 'Webinaire en direct Polar Tensor',
    happeningNow: 'En cours maintenant',
    peopleWatching: 'personnes regardent',
    react: 'Réagir',
    avgProfit: 'Profit moy.',
    startedIn: 'Depuis',
    clients: 'Clients',
    getStarted: 'Commencez maintenant, gagnez demain',
    joinThousands: "Rejoignez des milliers d'investisseurs qui bénéficient déjà de Polar Tensor",
    webinarEnded: 'Le webinaire est terminé',
    signUpNow: 'Inscrivez-vous maintenant',
    copyright: '© 2025 Polar Tensor. Tous droits réservés.',
  },
  zh: {
    videoFile: 'Polar_Tensor_Chinese.mp4',
    liveNow: '正在直播',
    watching: '正在观看',
    liveWebinar: '直播研讨会',
    description: '了解 Polar Tensor 如何通过 AI 驱动的交易技术革新未来，基于过往表现实现平均每月 22.04% 的收益',
    joinLiveNow: '立即加入直播',
    webinarInProgress: '研讨会正在进行中 — 在结束前立即加入',
    polarTensorLiveWebinar: 'Polar Tensor 直播研讨会',
    happeningNow: '正在进行中',
    peopleWatching: '人正在观看',
    react: '互动',
    avgProfit: '平均收益',
    startedIn: '始于',
    clients: '客户',
    getStarted: '现在开始，明天盈利',
    joinThousands: '加入已从 Polar Tensor 获益的数千名投资者',
    webinarEnded: '研讨会已结束',
    signUpNow: '立即注册',
    copyright: '© 2025 Polar Tensor. 版权所有。',
  },
  hi: {
    videoFile: 'Polar_Tensor_Hindi.mp4',
    liveNow: 'लाइव',
    watching: 'देख रहे हैं',
    liveWebinar: 'लाइव वेबिनार',
    description: 'जानें कि कैसे Polar Tensor AI-संचालित ट्रेडिंग के भविष्य को बदल रहा है, पिछले प्रदर्शन के आधार पर औसतन 22.04% मासिक लाभ के साथ',
    joinLiveNow: 'अभी लाइव जुड़ें',
    webinarInProgress: 'वेबिनार चल रहा है — समाप्त होने से पहले अभी जुड़ें',
    polarTensorLiveWebinar: 'Polar Tensor लाइव वेबिनार',
    happeningNow: 'अभी चल रहा है',
    peopleWatching: 'लोग देख रहे हैं',
    react: 'प्रतिक्रिया',
    avgProfit: 'औसत लाभ',
    startedIn: 'शुरुआत',
    clients: 'ग्राहक',
    getStarted: 'अभी शुरू करें, कल कमाएं',
    joinThousands: 'हजारों निवेशकों से जुड़ें जो पहले से ही Polar Tensor से लाभ उठा रहे हैं',
    webinarEnded: 'वेबिनार समाप्त हो गया',
    signUpNow: 'अभी साइन अप करें',
    copyright: '© 2025 Polar Tensor. सभी अधिकार सुरक्षित।',
  },
  th: {
    videoFile: 'Polar_Tensor_Thai.mp4',
    liveNow: 'ถ่ายทอดสด',
    watching: 'กำลังรับชม',
    liveWebinar: 'เว็บบินาร์สด',
    description: 'ค้นพบวิธีที่ Polar Tensor กำลังปฏิวัติอนาคตของการเทรดด้วย AI ด้วยกำไรเฉลี่ยรายเดือน 22.04% จากผลงานที่ผ่านมา',
    joinLiveNow: 'เข้าร่วมสดตอนนี้',
    webinarInProgress: 'เว็บบินาร์กำลังดำเนินอยู่ — เข้าร่วมก่อนจบ',
    polarTensorLiveWebinar: 'เว็บบินาร์สด Polar Tensor',
    happeningNow: 'กำลังดำเนินอยู่',
    peopleWatching: 'คนกำลังรับชม',
    react: 'รีแอค',
    avgProfit: 'กำไรเฉลี่ย',
    startedIn: 'เริ่มต้น',
    clients: 'ลูกค้า',
    getStarted: 'เริ่มต้นวันนี้ รับผลตอบแทนพรุ่งนี้',
    joinThousands: 'เข้าร่วมกับนักลงทุนหลายพันคนที่ได้รับประโยชน์จาก Polar Tensor แล้ว',
    webinarEnded: 'เว็บบินาร์จบลงแล้ว',
    signUpNow: 'สมัครสมาชิกเลย',
    copyright: '© 2025 Polar Tensor. สงวนลิขสิทธิ์.',
  },
  vi: {
    videoFile: 'Polar_Tensor_Vietnamese.mp4',
    liveNow: 'TRỰC TIẾP',
    watching: 'đang xem',
    liveWebinar: 'Hội thảo trực tuyến trực tiếp',
    description: 'Khám phá cách Polar Tensor đang cách mạng hóa tương lai giao dịch bằng AI với lợi nhuận trung bình hàng tháng 22,04% dựa trên hiệu suất quá khứ',
    joinLiveNow: 'Tham gia trực tiếp ngay',
    webinarInProgress: 'Hội thảo đang diễn ra — Tham gia ngay trước khi kết thúc',
    polarTensorLiveWebinar: 'Hội thảo trực tiếp Polar Tensor',
    happeningNow: 'Đang diễn ra',
    peopleWatching: 'người đang xem',
    react: 'Phản ứng',
    avgProfit: 'Lợi nhuận TB',
    startedIn: 'Từ',
    clients: 'Khách hàng',
    getStarted: 'Bắt đầu ngay, kiếm lời ngày mai',
    joinThousands: 'Tham gia cùng hàng nghìn nhà đầu tư đang hưởng lợi từ Polar Tensor',
    webinarEnded: 'Hội thảo đã kết thúc',
    signUpNow: 'Đăng ký ngay',
    copyright: '© 2025 Polar Tensor. Bảo lưu mọi quyền.',
  },
  id: {
    videoFile: 'Polar_Tensor_Indonesian.mp4',
    liveNow: 'SIARAN LANGSUNG',
    watching: 'menonton',
    liveWebinar: 'Webinar Langsung',
    description: 'Temukan bagaimana Polar Tensor merevolusi masa depan trading berbasis AI dengan rata-rata keuntungan bulanan 22,04% berdasarkan kinerja masa lalu',
    joinLiveNow: 'Gabung siaran langsung',
    webinarInProgress: 'Webinar sedang berlangsung — Gabung sekarang sebelum berakhir',
    polarTensorLiveWebinar: 'Webinar Langsung Polar Tensor',
    happeningNow: 'Sedang berlangsung',
    peopleWatching: 'orang menonton',
    react: 'Reaksi',
    avgProfit: 'Keuntungan Rata-rata',
    startedIn: 'Sejak',
    clients: 'Klien',
    getStarted: 'Mulai sekarang, raih untung besok',
    joinThousands: 'Bergabunglah dengan ribuan investor yang sudah mendapat manfaat dari Polar Tensor',
    webinarEnded: 'Webinar telah berakhir',
    signUpNow: 'Daftar sekarang',
    copyright: '© 2025 Polar Tensor. Hak cipta dilindungi.',
  },
  ja: {
    videoFile: 'Polar_Tensor_Japanese.mp4',
    liveNow: 'ライブ配信中',
    watching: '視聴中',
    liveWebinar: 'ライブウェビナー',
    description: 'Polar Tensorが過去の実績に基づく月平均22.04%の利益でAI駆動取引の未来をどのように革新しているかをご覧ください',
    joinLiveNow: '今すぐライブに参加',
    webinarInProgress: 'ウェビナー進行中 — 終了前に今すぐ参加',
    polarTensorLiveWebinar: 'Polar Tensor ライブウェビナー',
    happeningNow: '現在進行中',
    peopleWatching: '人が視聴中',
    react: 'リアクション',
    avgProfit: '平均利益',
    startedIn: '設立',
    clients: 'クライアント',
    getStarted: '今すぐ始めて、明日稼ごう',
    joinThousands: 'すでにPolar Tensorの恩恵を受けている何千人もの投資家に参加しましょう',
    webinarEnded: 'ウェビナーは終了しました',
    signUpNow: '今すぐ登録',
    copyright: '© 2025 Polar Tensor. 全著作権所有。',
  },
  bs: {
    videoFile: 'Polar_Tensor_Bosnian.mp4',
    liveNow: 'UŽIVO',
    watching: 'gleda',
    liveWebinar: 'Webinar uživo',
    description: 'Otkrijte kako Polar Tensor revolucionizira budućnost trgovanja pokretanog AI-jem sa prosječnim mjesečnim profitom od 22,04% na osnovu prethodnih rezultata',
    joinLiveNow: 'Pridruži se uživo',
    webinarInProgress: 'Webinar je u toku — Pridružite se prije nego što završi',
    polarTensorLiveWebinar: 'Polar Tensor Webinar uživo',
    happeningNow: 'Upravo se odvija',
    peopleWatching: 'osoba gleda',
    react: 'Reaguj',
    avgProfit: 'Prosj. profit',
    startedIn: 'Od',
    clients: 'Klijenata',
    getStarted: 'Počni sada, zarađuj sutra',
    joinThousands: 'Pridružite se hiljadama investitora koji već imaju koristi od Polar Tensora',
    webinarEnded: 'Webinar je završen',
    signUpNow: 'Registruj se sada',
    copyright: '© 2025 Polar Tensor. Sva prava zadržana.',
  },
  hu: {
    videoFile: 'Polar_Tensor_Hungarian.mp4',
    liveNow: 'ÉLŐ',
    watching: 'nézi',
    liveWebinar: 'Élő webinárium',
    description: 'Fedezze fel, hogyan forradalmasítja a Polar Tensor az AI-alapú kereskedés jövőjét havi átlagosan 22,04%-os nyereséggel a korábbi teljesítmény alapján',
    joinLiveNow: 'Csatlakozz élőben',
    webinarInProgress: 'A webinárium folyamatban van — Csatlakozz, mielőtt véget ér',
    polarTensorLiveWebinar: 'Polar Tensor élő webinárium',
    happeningNow: 'Éppen zajlik',
    peopleWatching: 'ember nézi',
    react: 'Reagálj',
    avgProfit: 'Átl. nyereség',
    startedIn: 'Alapítva',
    clients: 'Ügyfelek',
    getStarted: 'Kezdd el most, keress holnap',
    joinThousands: 'Csatlakozz több ezer befektetőhöz, akik már profitálnak a Polar Tensorból',
    webinarEnded: 'A webinárium véget ért',
    signUpNow: 'Regisztrálj most',
    copyright: '© 2025 Polar Tensor. Minden jog fenntartva.',
  },
  hr: {
    videoFile: 'Polar_Tensor_Croatian.mp4',
    liveNow: 'UŽIVO',
    watching: 'gleda',
    liveWebinar: 'Webinar uživo',
    description: 'Otkrijte kako Polar Tensor revolucionira budućnost trgovanja pokretanog AI-jem s prosječnim mjesečnim profitom od 22,04% na temelju prošlih rezultata',
    joinLiveNow: 'Pridruži se uživo',
    webinarInProgress: 'Webinar je u tijeku — Pridružite se prije nego što završi',
    polarTensorLiveWebinar: 'Polar Tensor Webinar uživo',
    happeningNow: 'Upravo se odvija',
    peopleWatching: 'osoba gleda',
    react: 'Reagiraj',
    avgProfit: 'Prosj. profit',
    startedIn: 'Od',
    clients: 'Klijenata',
    getStarted: 'Počni sada, zarađuj sutra',
    joinThousands: 'Pridružite se tisućama investitora koji već imaju koristi od Polar Tensora',
    webinarEnded: 'Webinar je završen',
    signUpNow: 'Registriraj se sada',
    copyright: '© 2025 Polar Tensor. Sva prava pridržana.',
  },
  sr: {
    videoFile: 'Polar_Tensor_Serbian.mp4',
    liveNow: 'УЖИВО',
    watching: 'гледа',
    liveWebinar: 'Вебинар уживо',
    description: 'Откријте како Polar Tensor револуционише будућност AI трговања са просечним месечним профитом од 22,04% на основу претходних резултата',
    joinLiveNow: 'Придружи се уживо',
    webinarInProgress: 'Вебинар је у току — Придружите се пре него што се заврши',
    polarTensorLiveWebinar: 'Polar Tensor Вебинар уживо',
    happeningNow: 'Управо се одвија',
    peopleWatching: 'особа гледа',
    react: 'Реагуј',
    avgProfit: 'Просечан профит',
    startedIn: 'Од',
    clients: 'Клијената',
    getStarted: 'Почни сада, зарађуј сутра',
    joinThousands: 'Придружите се хиљадама инвеститора који већ имају користи од Polar Тензора',
    webinarEnded: 'Вебинар је завршен',
    signUpNow: 'Региструј се сада',
    copyright: '© 2025 Polar Tensor. Сва права задржана.',
  },
  it: {
    videoFile: 'Polar_Tensor_Italian.mp4',
    liveNow: 'IN DIRETTA',
    watching: 'stanno guardando',
    liveWebinar: 'Webinar in diretta',
    description: 'Scopri come Polar Tensor sta rivoluzionando il futuro del trading basato sull\'AI con un profitto mensile medio del 22,04% basato sulle performance passate',
    joinLiveNow: 'Partecipa in diretta',
    webinarInProgress: 'Il webinar è in corso — Partecipa ora prima che finisca',
    polarTensorLiveWebinar: 'Webinar in diretta Polar Tensor',
    happeningNow: 'In corso ora',
    peopleWatching: 'persone stanno guardando',
    react: 'Reagisci',
    avgProfit: 'Profitto medio',
    startedIn: 'Dal',
    clients: 'Clienti',
    getStarted: 'Inizia ora, guadagna domani',
    joinThousands: 'Unisciti a migliaia di investitori che già beneficiano di Polar Tensor',
    webinarEnded: 'Il webinar è terminato',
    signUpNow: 'Iscriviti ora',
    copyright: '© 2025 Polar Tensor. Tutti i diritti riservati.',
  },
  ro: {
    videoFile: 'Polar_Tensor_Romanian.mp4',
    liveNow: 'ÎN DIRECT',
    watching: 'urmăresc',
    liveWebinar: 'Webinar în direct',
    description: 'Descoperă cum Polar Tensor revoluționează viitorul tradingului bazat pe AI cu un profit mediu lunar de 22,04% pe baza performanțelor anterioare',
    joinLiveNow: 'Alătură-te în direct',
    webinarInProgress: 'Webinarul este în desfășurare — Alătură-te acum înainte să se termine',
    polarTensorLiveWebinar: 'Webinar Polar Tensor în direct',
    happeningNow: 'Se întâmplă acum',
    peopleWatching: 'persoane urmăresc',
    react: 'Reacționează',
    avgProfit: 'Profit med.',
    startedIn: 'Din',
    clients: 'Clienți',
    getStarted: 'Începe acum, câștigă mâine',
    joinThousands: 'Alătură-te miilor de investitori care beneficiază deja de Polar Tensor',
    webinarEnded: 'Webinarul s-a încheiat',
    signUpNow: 'Înregistrează-te acum',
    copyright: '© 2025 Polar Tensor. Toate drepturile rezervate.',
  },
}
